import { useFormContext } from '@hooks/react-hook-form';
import { Button, Input } from '@new-components/elements';
import { CheckCircle } from '@new-components/shapes';

import ApplicationCard from '../../../../../application-card';
import SectionTitle from '../../../../../section-title';

import { PersonalContactProps } from './types';

const PersonalContact = (props: PersonalContactProps) => {
  const { readonly } = props;
  const {
    fieldsRef,
    formState: { isSubmitting, isSubmitSuccessful },
    trigger,
  } = useFormContext();

  return (
    <ApplicationCard>
      <SectionTitle title='Informasi Kontak Pribadi' />
      <div className='primary-phone-number-container'>
        <Input
          disabled
          ref={(e) => (fieldsRef.current['primaryPhoneNumber'] = e)}
          name='primaryPhoneNumber'
          type='tel'
          label='Nomor HP Utama'
        />
        <Button disabled variant='secondary' className='verified-btn'>
          <CheckCircle width={20} height={20} className='check-icon' />
          <span>Terverifikasi</span>
        </Button>
      </div>
      <Input
        ref={(e) => (fieldsRef.current['secondaryPhoneNumber'] = e)}
        disabled={readonly || (isSubmitting && !isSubmitSuccessful)}
        name='secondaryPhoneNumber'
        type='tel'
        label='Nomor HP Lainnya (Tidak Wajib)'
        onKeyUp={() => trigger('secondaryPhoneNumber')}
        placeholder={!readonly ? '08xxxxxxxxxx' : ''}
      />
    </ApplicationCard>
  );
};

export default PersonalContact;
